// What stays theirs for life once a product's access has ended (Adam, 3 Oct, docs/stage4-for-adam.md
// 6; decision 8's "yours for life"): which products, and the tile's line. Pure: no network, no React,
// no assets, so a test can import it as it is.

// The products whose access has ended for them that keep yours-for-life items, from hub.my_for_life
// (their own rows, so a staff member reading every catalogue row gets only their own), each with its
// catalogue row and how many items; never a product they have now (ownedProducts draws that one).
export function forLifeProducts(d, owned) {
  const byId = new Map(d.products.map(p => [p.id, p]))
  const out = new Map()
  for (const r of d.forLife || []) {
    const p = byId.get(r.product_id)
    if (!p || p.access_kind !== 'paid' || !['live', 'archived'].includes(p.state) || owned?.has(p.id)) continue
    const items = Number(r.items) || 0
    if (items < 1) continue
    out.set(p.id, { product: p, items })
  }
  return out
}

// "Access ended. 2 resources stay yours for life."
export const forLifeLine = n => `Access ended. ${n} ${n === 1 ? 'resource stays' : 'resources stay'} yours for life.`
